<!-- Barra de ações -->
<div class="po-row po-mb-3 po-pt-4">
  <div class="po-sm-12 projects-action-bar">
    <po-input
      class="projects-search-input"
      name="filterName"
      p-label=""
      p-placeholder="Buscar por nome..."
      [(ngModel)]="filterName"
      (p-change)="onSearch()"
    ></po-input>

    <po-button
      p-label="Buscar"
      p-kind="primary"
      p-icon="po-icon-search"
      [p-loading]="loading"
      (p-click)="onSearch()"
    ></po-button>

    <po-button
      p-label="Limpar"
      p-kind="secondary"
      p-icon="po-icon-close"
      (p-click)="onClearSearch()"
    ></po-button>

    <po-button
      p-label="Atualizar"
      p-kind="secondary"
      p-icon="po-icon-refresh"
      [p-loading]="loading"
      (p-click)="currentPage = 1; loadProjects()"
    ></po-button>
  </div>
</div>

<!-- Tabela de Projetos -->
<po-table
  [p-columns]="projectsColumns"
  [p-items]="projects"
  [p-loading]="loading"
  [p-sort]="true"
  [p-actions]="projectsActions"
  [p-show-more-disabled]="!hasMoreProjects"
  [p-literals]="{ noData: 'Nenhum projeto encontrado.', showMore: 'Carregar mais' }"
  (p-show-more)="loadMoreProjects()"
></po-table>

<!-- ─────────────────────────────────────────────────────────────────────────
     Modal: Editar Metadados do Projeto
───────────────────────────────────────────────────────────────────────────── -->
<po-modal
  #modalEdit
  [p-title]="'Editar Projeto: ' + (selectedProject?.name ?? '')"
  p-size="md"
  [p-primary-action]="modalEditPrimaryAction"
  [p-secondary-action]="modalEditSecondaryAction"
>
  <!-- Informações somente leitura -->
  <div class="po-row po-mb-2">
    <po-info
      class="po-sm-12 po-md-6"
      p-label="Chave Sonar"
      [p-value]="selectedProject?.sonar_key ?? ''"
    ></po-info>
    <po-info
      class="po-sm-12 po-md-6"
      p-label="Nome"
      [p-value]="selectedProject?.name ?? ''"
    ></po-info>
  </div>

  <div class="po-row">
    <po-input
      class="po-sm-12 po-md-6"
      name="formArea"
      p-label="Área"
      p-placeholder="Ex: Financeiro"
      p-max-length="100"
      [(ngModel)]="formArea"
    ></po-input>

    <po-input
      class="po-sm-12 po-md-6"
      name="formModule"
      p-label="Módulo"
      p-placeholder="Ex: Contas a Pagar"
      p-max-length="100"
      [(ngModel)]="formModule"
    ></po-input>
  </div>

  <div class="po-row">
    <po-input
      class="po-sm-12 po-md-6"
      name="formPo"
      p-label="PO"
      p-placeholder="Nome do Product Owner"
      p-max-length="100"
      [(ngModel)]="formPo"
    ></po-input>

    <po-input
      class="po-sm-12 po-md-6"
      name="formSegment"
      p-label="Segmento"
      p-placeholder="Ex: Serviços"
      p-max-length="100"
      [(ngModel)]="formSegment"
    ></po-input>
  </div>

  <div class="po-row">
    <po-input
      class="po-sm-12 po-md-6"
      name="formSquad"
      p-label="Squad"
      p-placeholder="Nome da squad"
      p-max-length="100"
      [(ngModel)]="formSquad"
    ></po-input>

    <po-input
      class="po-sm-12 po-md-6"
      name="formTribe"
      p-label="Tribe"
      p-placeholder="Nome da tribe"
      p-max-length="100"
      [(ngModel)]="formTribe"
    ></po-input>
  </div>
</po-modal>
